<div
  class="custom-dropdown"
  role="combobox"
  tabindex="0"
  [attr.aria-expanded]="active"
  [attr.aria-disabled]="disabled()"
  aria-haspopup="listbox"
  [attr.aria-activedescendant]="focusedIndex >= 0 ? 'dropdown-option-' + filteredOptions[focusedIndex]?.id : null"
  (clickOutside)="clickedOutside()"
  (keydown)="onKeydown($event)"
  [class.disabled]="disabled()"
>
  <div class="custom-dropdown__input" (click)="clickInput()" [class.has-length]="selectedOptionsCount > 0">
    <span> {{ selectedOptions }} </span>
  </div>
  @if (selectedOptionsCount < 2) {
    <svg-icon src="assets/images/icons/select-arrows.svg" [class.test]="disabled()"></svg-icon>
  }

  @if (selectedOptionsCount > 1) {
    <span class="custom-dropdown__count">{{ selectedOptionsCount }}</span>
  }
  @if (active) {
    <div class="custom-dropdown__overflow">
      @if (searchable()) {
        <div class="custom-dropdown__search">
          <svg-icon src="assets/images/icons/search.svg"></svg-icon>
          <input type="text" [(ngModel)]="searchValue" placeholder="{{ 'Form.Placeholder.Search' | translate }}" />
        </div>
      }
      <ul role="listbox" [attr.aria-multiselectable]="multiselect">
        @for (option of filteredOptions; track $index) {
          <li
            role="option"
            [id]="'dropdown-option-' + option.id"
            [attr.aria-selected]="option.select"
            [class.selected]="option.select"
            [class.focused]="$index === focusedIndex"
            [class.disabled]="option.disabled"
            (click)="optionClick(option.id)"
          >
            {{ option.name }}
          </li>
        }
      </ul>
    </div>
  }
</div>
